import { useSyncExternalStore } from "react";

const getSnapshot = () => document.documentElement.classList.contains("dark");
const getServerSnapshot = () => false;

const subscribe = (onChange: () => void) => {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
  return () => observer.disconnect();
};

/**
 * Detects whether the app is in dark mode by observing
 * the Tailwind `dark` class on the document element.
 * Client mounts read it immediately so newly opened panels do not flash the light theme.
 */
export const useIsDarkMode = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
